export default {
  name: 'project_benefiting',
  component_path: 'modules/procedures/blocks/BlockBenefiting'
}